import { useEffect, useRef, useState } from 'react'

import { EXPERIMENT_VARIATION } from '../../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../../model/Experiment.types'

export const useDetectScrollUpForHeaderStickyToggleExperiment = (
  experiment: ExperimentType,
): boolean => {
  const [isScrollingUp, setIsScrollingUp] = useState(false)
  const lastScrollY = useRef(0)

  useEffect(() => {
    if (
      !experiment.isEnabled ||
      experiment.variant !== EXPERIMENT_VARIATION.V3
    ) {
      return
    }

    const handleScroll = (): void => {
      const currentScrollY = window.scrollY

      if (currentScrollY < lastScrollY.current) {
        setIsScrollingUp(true)
      } else {
        setIsScrollingUp(false)
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return (): void => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [experiment])

  return isScrollingUp
}
